import { useSliderLayout } from '../hooks/useSliderLayout';

import IconCaret from '../../../icons/IconCaret';

const SliderRightArrow = ({ arrowSize }: any) => {
	const { blockClass } = useSliderLayout();
	return (
		<button
			className={`sliderRightArrow sliderArrows sliderRightArrow--${blockClass} sliderArrows--${blockClass} vtex-slider-layout-0-x-sliderRightArrow vtex-slider-layout-0-x-sliderRightArrow--${blockClass} right-0 vtex-slider-layout-0-x-sliderArrows vtex-slider-layout-0-x-sliderArrows--${blockClass} absolute transparent ma2 flex items-center justify-center bn outline-0 pointer`}
			aria-controls="slider-items"
			aria-label="Next Slide"
			style={{
				background: 'transparent',
			}}
		>
			<IconCaret
				orientation={'right'}
				handle={`caretIcon caretIcon--${blockClass} vtex-slider-layout-0-x-caretIcon vtex-slider-layout-0-x-caretIcon--${blockClass}`}
				size={arrowSize}
				thin
			/>
		</button>
	);
};

export default SliderRightArrow;
